module.exports = __webpack_public_path__ + "img/reviews.d3da0f26.svg";